import { Spinner } from "@climatepartner/components/Spinner";
import { Suspense } from "react";
import { Outlet } from "react-router-dom";

import { PcfMaintenanceModeProvider } from "../../shared/maintenance/maintenance-mode-provider";
import { PCF_ROUTE_SEGMENTS } from "../../shared/routing/paths/pcf";
import { commonLabels } from "../../shared/ui/labels/common-labels";
import { PcfAuthorisationGuard } from "./guards/pcf-authorisation.guard";
import { PcfDetailsPage, PCFHomePage, TemplateUploadPage } from "./lazy-pages";

export const PCFRoutes = {
  element: (
    <PcfAuthorisationGuard>
      <PcfMaintenanceModeProvider>
        <Suspense fallback={<Spinner />}>
          <Outlet />
        </Suspense>
      </PcfMaintenanceModeProvider>
    </PcfAuthorisationGuard>
  ),
  path: PCF_ROUTE_SEGMENTS.root,
  handle: { crumb: commonLabels.navigation.pcf },
  children: [
    { index: true, element: <PCFHomePage /> },
    { path: PCF_ROUTE_SEGMENTS.uploadTemplate, handle: { crumb: "Upload Template" }, element: <TemplateUploadPage /> },
    { path: PCF_ROUTE_SEGMENTS.calculationId, element: <PcfDetailsPage /> },
  ],
};
